import { render, staticRenderFns } from "./RightsEdit.vue?vue&type=template&id=028aac36&scoped=true&"
import script from "./RightsEdit.vue?vue&type=script&lang=js&"
export * from "./RightsEdit.vue?vue&type=script&lang=js&"
import style0 from "./RightsEdit.vue?vue&type=style&index=0&id=028aac36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028aac36",
  null
  
)

export default component.exports